/**
 * Types re-exported from `components["schemas"]` for the pilots feature, so
 * call sites do not reach into `@/api/schema` directly. Mirrors the shape
 * `src/api/types.ts` uses for other features (departments, consents, …).
 */
import type { components } from '@/api/schema';

export type Pilot = Required<
  Omit<
    components['schemas']['Pilot'],
    'start_date' | 'end_date' | 'recommendation' | 'scaled_at' | 'created_by'
  >
> &
  Pick<
    components['schemas']['Pilot'],
    'start_date' | 'end_date' | 'recommendation' | 'scaled_at' | 'created_by'
  >;

export type PilotEvaluation = Required<
  Omit<
    components['schemas']['PilotEvaluation'],
    'conclusions' | 'satisfaction_score' | 'created_by'
  >
> &
  Pick<
    components['schemas']['PilotEvaluation'],
    'conclusions' | 'satisfaction_score' | 'created_by'
  >;

export type PilotStatus = NonNullable<components['schemas']['Pilot']['status']>;

export const PILOT_STATUSES: PilotStatus[] = [
  'draft',
  'baseline',
  'active',
  'interim_review',
  'final_review',
  'completed',
  'scaled',
];

/** One step forward or back — mirrors `api_pilots::ALLOWED_TRANSITIONS`. */
export const PILOT_TRANSITIONS: Record<PilotStatus, PilotStatus[]> = {
  draft: ['baseline'],
  baseline: ['draft', 'active'],
  active: ['baseline', 'interim_review'],
  interim_review: ['active', 'final_review'],
  final_review: ['interim_review', 'completed'],
  completed: ['final_review', 'scaled'],
  scaled: [],
};

export type EvaluationPhase = NonNullable<components['schemas']['PilotEvaluation']['phase']>;
export const EVALUATION_PHASES: EvaluationPhase[] = ['baseline', 'interim', 'final'];

/** Maps a phase to the status transition that "reaching" it corresponds to
 * in the 3 fase-knoppen UI (Nulmeting/Tussentijdse evaluatie/Eindevaluatie). */
export const PHASE_STATUS: Record<EvaluationPhase, PilotStatus> = {
  baseline: 'baseline',
  interim: 'interim_review',
  final: 'final_review',
};
